exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active,\n.fade-leave-active {\n  transition: opacity 0.1s;\n}\n.fade-enter,\n  .fade-leave-to\n  /* .fade-leave-active in <2.1.8 */\n\n {\n  opacity: 0;\n}\n", ""]);

// exports
